import React from "react";
import { Info } from "lucide-react";
import { cn } from "../../lib/utils";

interface InfoContainerProps {
  message: string | React.ReactNode;
  className?: string;
  iconSize?: number;
}

const InfoContainer: React.FC<InfoContainerProps> = ({
  message,
  className,
  iconSize = 14
}) => {
  return (
    <div className={cn(
      "mb-4 p-3 lg:p-4 bg-purple-50 rounded-lg border border-purple-100 flex items-start gap-2 lg:gap-3",
      className
    )}>
      <Info size={iconSize} className="text-[#885ABB] mt-0.5 flex-shrink-0" />
      <div className="text-[11px] lg:text-xs text-purple-700 leading-relaxed font-normal">
        {message}
      </div>
    </div>
  );
};

export default InfoContainer;
